__turbopack_context__.v({
  "ornament": "Star-module-scss-module__plQRJW__ornament",
  "rays5": "Star-module-scss-module__plQRJW__rays5",
  "rays6": "Star-module-scss-module__plQRJW__rays6",
  "rays8": "Star-module-scss-module__plQRJW__rays8",
  "star": "Star-module-scss-module__plQRJW__star",
  "svgIcon": "Star-module-scss-module__plQRJW__svgIcon",
  "svgIcon8": "Star-module-scss-module__plQRJW__svgIcon8",
});
